import React, { PureComponent } from 'react';
import b from 'b_';

import './mobile-publications-page-header.css';

import Theme from '@interfaces/themes';
import PublicationsFilterYear from '@components/publications-year-filter';
import ThemesSelect from '@components/themes-select';

interface Props {
    themes: Theme[];
    selectedTheme: string | null;
    year: string | null;
    onThemeChange(themeSlug?: string): void;
    onYearChange(year?: number): void;
}

const class_ = b.with('mobile-publications-page-header');

export default class MobilePublicationsPageHeader extends PureComponent<Props> {
    public render() {
        const { year, selectedTheme, themes, onThemeChange, onYearChange } = this.props;

        return (
            <div className={class_()}>
                <h1 className="block__title">Publications</h1>

                <ThemesSelect
                    selectedTheme={selectedTheme}
                    themes={themes}
                    onThemeChange={onThemeChange}
                />
                <PublicationsFilterYear
                    size="l"
                    selectedYear={year}
                    onYearChange={onYearChange}
                    themeSlug={selectedTheme}
                />
            </div>
        );
    }
}
